import Record from "./Record";

export default class Resource {

  constructor(server, resourceName){
    this.server = server;
    this.resourceName = resourceName;
  }

  read(id){
    return this.call("read", {id: id}).then(data => this.getRecord(data));
  }

  update(id, dto){
    return this.call("update", {id: id, ...dto}).then(data => this.getRecord(data));
  }

  create(dto){
    return this.call("create", dto).then(data => this.getRecord(data));
  }

  del(id){
    return this.call("delete", {id: id});
  }

  call(method, params){
    return this.server(this.resourceName+"."+method, params)
  }

  getRecord(data){
    return new Record(this, data);
  }

}


// WEBPACK FOOTER //
// ./src/Resource/Resource.js